/**
 * WordPress dependencies
 */

import { store, getContext, getServerState, getElement } from '@wordpress/interactivity';

function getSecureholidayLanguage(lang) {
    const resolvedLang = typeof lang === 'string' ? lang.trim().toLowerCase() : '';
    const langMap = {
        fr: 'fr',
        en: 'en',
        de: 'de',
        nl: 'nl',
    };

    return langMap[resolvedLang] || 'fr';
}


const { state } = store('gt/ctv', {
    actions: {
        syncRegionsWithCampings: () => {
            try {
                const element = getElement();
                const regionSelect = element.ref.querySelector('.gt-select-region');
                if (!regionSelect) return;

                const globalStore = store('gt/ctv');
                const campings = globalStore?.state?.campings || [];
                if (!Array.isArray(campings) || campings.length === 0) return;

                const normalize = (str) => (str || '')
                    .toString()
                    .trim();

                // Collecter régions uniques depuis campings affichés
                const regionsSet = new Map();
                campings.forEach(c => {
                    const region = normalize(c.region);
                    if (region) regionsSet.set(region, region);
                });

                // Valeur sélectionnée actuelle
                const current = regionSelect.value;

                // Réduire la liste aux régions présentes; conserver la première option "Toutes"
                const keepFirst = regionSelect.options[0]?.value === '';
                while (regionSelect.options.length > (keepFirst ? 1 : 0)) {
                    regionSelect.remove(keepFirst ? 1 : 0);
                }

                // Ajouter options triées
                const sorted = Array.from(regionsSet.keys()).sort((a,b)=>a.localeCompare(b));
                sorted.forEach(region => {
                    const opt = document.createElement('option');
                    opt.value = region;
                    opt.textContent = region;
                    regionSelect.appendChild(opt);
                });

                // Restaurer sélection si encore valide, sinon reset
                if (current && regionsSet.has(current)) {
                    regionSelect.value = current;
                } else {
                    regionSelect.value = '';
                    state.gtRegion = '';
                }
            } catch (e) {
                // no-op
            }
        },
        syncDepartmentsWithCampings: () => {
            try {
                const element = getElement();
                const departmentSelect = element.ref.querySelector('.gt-select-department');
                if (!departmentSelect) return;

                const globalStore = store('gt/ctv');
                const campings = globalStore?.state?.campings || [];
                if (!Array.isArray(campings) || campings.length === 0) return;

                const normalize = (str) => (str || '')
                    .toString()
                    .trim();

                // Départements à exclure (ne font pas partie du Grand Est)
                const excludedDepartments = ['Aisne', 'Saône-et-Loire'];
                
                // Collecter départements uniques depuis campings affichés
                const departmentsSet = new Map();
                campings.forEach(c => {
                    const department = normalize(c.department || c.administrativeZone2);
                    if (department && !excludedDepartments.includes(department)) {
                        departmentsSet.set(department, department);
                    }
                });

                // Valeur sélectionnée actuelle
                const current = departmentSelect.value;

                // Réduire la liste aux départements présents; conserver la première option "Tous"
                const keepFirst = departmentSelect.options[0]?.value === '';
                while (departmentSelect.options.length > (keepFirst ? 1 : 0)) {
                    departmentSelect.remove(keepFirst ? 1 : 0);
                }

                // Ajouter options triées
                const sorted = Array.from(departmentsSet.keys()).sort((a,b)=>a.localeCompare(b));
                sorted.forEach(department => {
                    const opt = document.createElement('option');
                    opt.value = department;
                    opt.textContent = department;
                    departmentSelect.appendChild(opt);
                });

                // Restaurer sélection si encore valide, sinon reset
                if (current && departmentsSet.has(current)) {
                    departmentSelect.value = current;
                } else {
                    departmentSelect.value = '';
                    state.gtDepartment = '';
                }
            } catch (e) {
                // no-op
            }
        },
        changeNbPers: (e) => {
            const context = getContext();
            let nbPers = e.target.value;
            context.gtNbPers = nbPers;
            state.gtNbPers = nbPers;
            
            // Déclencher le filtrage automatique si pas de bouton submit
            const formContainer = e.target.closest('.gt-ws-ctv-form-resa');
            if (formContainer && formContainer.querySelector('button[type="submit"], button[data-wp-on--click="actions.submitForm"]') === null) {
                store('gt/ctv').actions.filterCampingsByFormData();
            }
        },
        changeType: (e) => {
            const context = getContext();
            let gtType = e.target.value;
            context.gtType = [gtType];
            state.gtType = [gtType];
            Cookies.set('gtType', [gtType]);
        },
        changeCamping: (e) => {
            const context = getContext();
            let gtCamping = e.target.value;
            context.gtCamping = gtCamping;
            state.gtCamping = gtCamping;
        },
        changeDepartment: (e) => {
            const context = getContext();
            let gtDepartment = e.target.value;
            context.gtDepartment = gtDepartment;
            state.gtDepartment = gtDepartment;
            Cookies.set('gtDepartment', gtDepartment);

            // Mettre à jour la liste des campings visibles sur la carte selon le département
            try {
                const normalize = (str) => (str || '')
                    .toString()
                    .trim()
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/\p{Diacritic}/gu, '');

                const selectedDepartment = (gtDepartment || '').toString().trim();
                const normalizedSelected = normalize(selectedDepartment);
                // Si aucun département sélectionné, afficher tous les marqueurs (liste vide = tous)
                if (!selectedDepartment) {
                    state.visibleCampingsIds = [];
                } else if (Array.isArray(state.campings)) {
                    const matchingIds = state.campings
                        .filter(c => {
                            const campingDepartment = normalize(c.department || c.administrativeZone2 || '');
                            return campingDepartment === normalizedSelected || (c.department || c.administrativeZone2) === selectedDepartment;
                        })
                        .map(c => c.idSite?.toString())
                        .filter(Boolean);
                    state.visibleCampingsIds = matchingIds;
                }

                // Déclencher la mise à jour de la carte si disponible
                if (store('gt/ctv')?.actions?.updateMap) {
                    store('gt/ctv').actions.updateMap();
                }
            } catch (err) {
                console.error('Erreur lors du filtrage des marqueurs par département:', err);
            }
            
            // Filtrer les campings côté client avec display: none au lieu de recharger la page
            // Vérifier si on est sur une page avec des campings (listing)
            const campingsQueryBlock = document.querySelector('.wp-block-query[data-namespace="gt-ws-ctv-campings"]');
            const campingsBlock = document.querySelector('.gt-ws-ctv-campings-block');
            const queryBlocks = document.querySelectorAll('.wp-block-query');
            let hasCampingElements = false;
            for (let i = 0; i < queryBlocks.length; i++) {
                if (queryBlocks[i].querySelector('.camping, .post-type-camping, [data-gt-camping], [data-department]')) {
                    hasCampingElements = true;
                    break;
                }
            }
            const hasCampingsBlock = campingsQueryBlock || campingsBlock || hasCampingElements;
            
            // Si on est sur une page de listing de campings, filtrer côté client
            if (hasCampingsBlock) {
                // Fonction de normalisation pour comparer les départements
                const normalize = (str) => (str || '')
                    .toString()
                    .trim()
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/\p{Diacritic}/gu, '');
                
                const departmentValue = typeof gtDepartment === 'string' ? gtDepartment.trim() : (gtDepartment ? String(gtDepartment).trim() : '');
                const normalizedSelected = departmentValue ? normalize(departmentValue) : '';
                
                // Trouver tous les éléments de camping dans le bloc Query Loop
                const campingElements = document.querySelectorAll('.wp-block-query[data-namespace="gt-ws-ctv-campings"] li, .gt-ws-ctv-campings-block li, [data-department]');
                
                campingElements.forEach(campingElement => {
                    const campingDepartment = campingElement.getAttribute('data-department');
                    
                    if (!departmentValue || departmentValue === '') {
                        // Aucun département sélectionné : afficher tous les campings
                        campingElement.style.display = '';
                    } else if (campingDepartment) {
                        // Comparer le département du camping avec le département sélectionné
                        const normalizedCampingDepartment = normalize(campingDepartment);
                        const matches = normalizedCampingDepartment === normalizedSelected || campingDepartment === departmentValue;
                        campingElement.style.display = matches ? '' : 'none';
                    } else {
                        // Si le camping n'a pas d'attribut data-department, le masquer par défaut
                        campingElement.style.display = 'none';
                    }
                });
                
                // Mettre à jour l'URL sans recharger la page (pour l'historique)
                const url = new URL(window.location.href);
                if (departmentValue !== '') {
                    url.searchParams.set('department', departmentValue);
                } else {
                    url.searchParams.delete('department');
                }
                window.history.replaceState({}, '', url.toString());
            } else if (!state.gtArrival || !state.gtDeparture || !state.gtNbPers) {
                // Si pas de page de campings mais dates non définies, mettre à jour l'URL
                const url = new URL(window.location.href);
                const departmentValue = typeof gtDepartment === 'string' ? gtDepartment.trim() : (gtDepartment ? String(gtDepartment).trim() : '');
                if (departmentValue !== '') {
                    url.searchParams.set('department', departmentValue);
                } else {
                    url.searchParams.delete('department');
                }
                import('@wordpress/interactivity-router').then(router => {
                    router.actions.navigate(url.toString(), {
                        force: true,
                        replace: true
                    });
                });
            } else {
                // Mode submit manuel: on conserve le département localement
                // et on laisse l'utilisateur cliquer sur Rechercher.
                const url = new URL(window.location.href);
                const departmentValue = typeof gtDepartment === 'string' ? gtDepartment.trim() : (gtDepartment ? String(gtDepartment).trim() : '');
                if (departmentValue !== '') {
                    url.searchParams.set('department', departmentValue);
                } else {
                    url.searchParams.delete('department');
                }
                window.history.replaceState({}, '', url.toString());
            }
        },
        changeRegion: (e) => {
            const context = getContext();
            let gtRegion = e.target.value;
            context.gtRegion = gtRegion;
            state.gtRegion = gtRegion;
            Cookies.set('gtRegion', gtRegion);

            // Mettre à jour la liste des campings visibles sur la carte selon la région
            try {
                const normalize = (str) => (str || '')
                    .toString()
                    .trim()
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/\p{Diacritic}/gu, '');

                const selectedRegion = (gtRegion || '').toString().trim();
                const normalizedSelected = normalize(selectedRegion);
                // Si aucune région sélectionnée, afficher tous les marqueurs (liste vide = tous)
                if (!selectedRegion) {
                    state.visibleCampingsIds = [];
                } else if (Array.isArray(state.campings)) {
                    const matchingIds = state.campings
                        .filter(c => {
                            const campingRegion = (c.region || '').toString().trim();
                            return normalize(campingRegion) === normalizedSelected || campingRegion === selectedRegion;
                        })
                        .map(c => c.idSite?.toString())
                        .filter(Boolean);
                    state.visibleCampingsIds = matchingIds;
                }

                // Déclencher la mise à jour de la carte si disponible
                if (store('gt/ctv')?.actions?.updateMap) {
                    store('gt/ctv').actions.updateMap();
                }
            } catch (err) {
                console.error('Erreur lors du filtrage des marqueurs par région:', err);
            }
            
            // Filtrer les campings côté client avec display: none au lieu de recharger la page
            // Vérifier si on est sur une page avec des campings (listing)
            const campingsQueryBlock = document.querySelector('.wp-block-query[data-namespace="gt-ws-ctv-campings"]');
            const campingsBlock = document.querySelector('.gt-ws-ctv-campings-block');
            const queryBlocks = document.querySelectorAll('.wp-block-query');
            let hasCampingElements = false;
            for (let i = 0; i < queryBlocks.length; i++) {
                if (queryBlocks[i].querySelector('.camping, .post-type-camping, [data-gt-camping], [data-region]')) {
                    hasCampingElements = true;
                    break;
                }
            }
            const hasCampingsBlock = campingsQueryBlock || campingsBlock || hasCampingElements;
            
            // Si on est sur une page de listing de campings, filtrer côté client
            if (hasCampingsBlock) {
                // Fonction de normalisation pour comparer les régions
                const normalize = (str) => (str || '')
                    .toString()
                    .trim()
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/\p{Diacritic}/gu, '');
                
                const regionValue = typeof gtRegion === 'string' ? gtRegion.trim() : (gtRegion ? String(gtRegion).trim() : '');
                const normalizedSelected = regionValue ? normalize(regionValue) : '';
                
                // Trouver tous les éléments de camping dans le bloc Query Loop
                const campingElements = document.querySelectorAll('.wp-block-query[data-namespace="gt-ws-ctv-campings"] li, .gt-ws-ctv-campings-block li, [data-region]');
                
                campingElements.forEach(campingElement => {
                    const campingRegion = campingElement.getAttribute('data-region');
                    
                    if (!regionValue || regionValue === '') {
                        // Aucune région sélectionnée : afficher tous les campings
                        campingElement.style.display = '';
                    } else if (campingRegion) {
                        // Comparer la région du camping avec la région sélectionnée
                        const normalizedCampingRegion = normalize(campingRegion);
                        const matches = normalizedCampingRegion === normalizedSelected || campingRegion === regionValue;
                        campingElement.style.display = matches ? '' : 'none';
                    } else {
                        // Si le camping n'a pas d'attribut data-region, le masquer par défaut
                        campingElement.style.display = 'none';
                    }
                });
                
                // Mettre à jour l'URL sans recharger la page (pour l'historique)
                const url = new URL(window.location.href);
                if (regionValue !== '') {
                    url.searchParams.set('region', regionValue);
                } else {
                    url.searchParams.delete('region');
                }
                window.history.replaceState({}, '', url.toString());
            } else if (!state.gtArrival || !state.gtDeparture || !state.gtNbPers) {
                // Si pas de page de campings mais dates non définies, mettre à jour l'URL
                const url = new URL(window.location.href);
                const regionValue = typeof gtRegion === 'string' ? gtRegion.trim() : (gtRegion ? String(gtRegion).trim() : '');
                if (regionValue !== '') {
                    url.searchParams.set('region', regionValue);
                } else {
                    url.searchParams.delete('region');
                }
                import('@wordpress/interactivity-router').then(router => {
                    router.actions.navigate(url.toString(), {
                        force: true,
                        replace: true
                    });
                });
            } else {
                // Si les dates sont définies et qu'on n'est pas sur une page de campings, utiliser submitForm
                store('gt/ctv').actions.submitForm();
            }
        },
        sortHebergements: (e) => {
            const domSort = document.querySelector('.gt-hebergements-sort input[type="radio"]:checked');
            if (domSort) {
            state.sort_order = domSort.value;
            }
            document.querySelectorAll('.wp-block-post-template').forEach(container => {
            const hebergements = [...container.querySelectorAll('.hebergement')];
            hebergements.sort((a, b) => {
                const priceA = parseFloat(a.querySelector('.gt-ws-ctv-data-price')?.dataset.gtPrice) || 0;
                const priceB = parseFloat(b.querySelector('.gt-ws-ctv-data-price')?.dataset.gtPrice) || 0;
                return state.sort_order === 'asc' ? priceA - priceB : priceB - priceA;
            });
            const fragment = document.createDocumentFragment();
            hebergements.forEach(hebergement => fragment.appendChild(hebergement));
            container.appendChild(fragment);
            });
        },  
        setCaleran: () => {
            let language = 'fr';
            if (jQuery('html').attr('lang')) {
                language = jQuery('html').attr('lang').slice(0, 2);
            }

            const context = getContext();
            const { gtArrival, gtDeparture } = state;

            const element = getElement();

            const generateRanges = (arrivalDate) => {
                const arrivalMoment = moment(arrivalDate);
                const ranges = [];

                const getNextWeekday = (date, weekday) => {
                    let diff = weekday - date.day();
                    if (diff <= 0) diff += 7;
                    return date.clone().add(diff, 'days');
                };

                ranges.push({
                    title: '1 semaine',
                    startDate: arrivalMoment,
                    endDate: arrivalMoment.clone().add(1, 'weeks')
                });

                ranges.push({
                    title: '2 semaines',
                    startDate: arrivalMoment,
                    endDate: arrivalMoment.clone().add(2, 'weeks')
                });

                ranges.push({
                    title: '3 semaines',
                    startDate: arrivalMoment,
                    endDate: arrivalMoment.clone().add(3, 'weeks')
                });

                const startWednesday = getNextWeekday(arrivalMoment, 3);
                ranges.push({
                    title: 'Du mercredi au mercredi',
                    startDate: startWednesday,
                    endDate: startWednesday.clone().add(1, 'weeks')
                });

                const startFriday = getNextWeekday(arrivalMoment, 5);
                ranges.push({
                    title: 'Du vendredi au vendredi',
                    startDate: startFriday,
                    endDate: startFriday.clone().add(1, 'weeks')
                });

                const startSaturday = getNextWeekday(arrivalMoment, 6);
                ranges.push({
                    title: 'Du samedi au samedi',
                    startDate: startSaturday,
                    endDate: startSaturday.clone().add(1, 'weeks')
                });

                return ranges;
            };

            const bindMobileCaleranTapGuard = () => {
                const selector = '.gt-caleran-merged, .gt-caleran-arrival, .gt-caleran-departure';

                jQuery(document)
                    .off('touchend.gtCaleranTapGuard', selector)
                    .on('touchend.gtCaleranTapGuard', selector, function (e) {
                        if (window.innerWidth > 768) return;
                        e.preventDefault();
                        e.stopPropagation();
                        const instance = jQuery(this).data('caleran');
                        if (instance && typeof instance.showDropdown === 'function') {
                            instance.showDropdown();
                        }
                    });

                jQuery(document)
                    .off('click.gtCaleranTapGuard', selector)
                    .on('click.gtCaleranTapGuard', selector, function (e) {
                        if (window.innerWidth > 768) return;
                        e.preventDefault();
                        e.stopPropagation();
                    });
            };

            if(jQuery('.gt-caleran-merged').length){
                jQuery('.gt-caleran-merged').caleran({
                    startDate: moment(gtArrival),
                    endDate: moment(gtDeparture),
                    minDate: moment(state.openingDate) < moment() ? moment() : moment(state.openingDate),
                    maxDate: moment(state.closingDate),
                    hideOutOfRange: true,
                    enableSwipe: true,
                    startOnMonday: true,
                    enableKeyboard: true,
                    autoCloseOnSelect: false,
                    locale: language,
                    enableMonthSwitcher: true,
                    enableYearSwitcher: true,
                    ranges: generateRanges(gtArrival),
                    format: language === "en" ? "DD/MM/YYYY" : "DD/MM/YYYY",
                    onafterselect: function (caleran, startDate, endDate) {
                        if (!startDate || !endDate) {
                            return;
                        }

                        state.gtArrival = startDate.format('DD/MM/YYYY');
                        state.gtDeparture = endDate.format('DD/MM/YYYY');
                                                
                        if (caleran.$elem.closest('.gt-ws-ctv-form-resa').find('button[type="submit"], button[data-wp-on--click="actions.submitForm"]').length <= 0) {                        
                            state.isLoading = true;
                            state.loaded = false;
                            let form = caleran.$elem.closest('.gt-ws-ctv-form-resa');
                            form.get(0).dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                        }
                        
                        caleran.config.ranges = generateRanges(state.gtArrival);
                        caleran.reDrawCalendars();

                        jQuery(".gt-caleran-merged, .gt-caleran-arrival, .gt-arrival-departure").each(function(){
                            const caleranInstance = jQuery(this).data("caleran");
                            caleranInstance.config.startDate = startDate;
                            caleranInstance.config.endDate = endDate;
                            caleranInstance.reDrawCalendars();
                        });

                        caleran.hideDropdown();

                    }
                });
            }
            else{

                var startDate, endDate, startInstance, endInstance;
                var fillInputs = function () {
                    startInstance.$elem.val(startDate ? startDate.locale(startInstance.config.format).format(startInstance.config.format) : "");
                    endInstance.$elem.val(endDate ? endDate.locale(endInstance.config.format).format(endInstance.config.format) : "");
                };

                jQuery('.gt-caleran-arrival').caleran({
                    startDate: moment(gtArrival),
                    endDate: moment(gtDeparture),
                    minDate: moment(state.openingDate) < moment() ? moment() : moment(state.openingDate),
                    maxDate: moment(state.closingDate),
                    hideOutOfRange: true,
                    enableSwipe: true,
                    startOnMonday: true,
                    enableKeyboard: true,
                    autoCloseOnSelect: true,
                    locale: language,
                    enableMonthSwitcher: true,
                    enableYearSwitcher: true,
                    ranges: generateRanges(gtArrival),
                    format: language === "en" ? "DD/MM/YYYY" : "DD/MM/YYYY",
                    oninit: function (instance) {
                        startInstance = instance;
                        if (!instance.config.startEmpty && instance.config.startDate) {
                            instance.$elem.val(instance.config.startDate.locale(instance.config.format).format(instance.config.format));
                            startDate = instance.config.startDate.clone();
                        }
                    },
                    onbeforeshow: function (instance) {
                        if (startDate) {
                            startInstance.config.startDate = startDate;
                            endInstance.config.startDate = startDate;
                        }
                        if (endDate) {
                            startInstance.config.endDate = endDate.clone();
                            endInstance.config.endDate = endDate.clone();
                        }
                        fillInputs();
                        instance.updateHeader();
                        instance.reDrawCells();
                    },
                    onfirstselect: function (instance, start) {
                        startDate = start.clone();
                        startInstance.globals.startSelected = false;
                        startInstance.hideDropdown();
                        endInstance.showDropdown();
                        endInstance.config.minDate = startDate.clone();
                        endInstance.config.startDate = startDate.clone();
                        endInstance.config.endDate = null;
                        endInstance.globals.startSelected = true;
                        endInstance.globals.endSelected = false;
                        endInstance.globals.firstValueSelected = true;
                        endInstance.setDisplayDate(start);
                        if (endDate && startDate.isAfter(endDate)) {
                            endInstance.globals.endDate = endDate.clone();
                        }
                        endInstance.updateHeader();
                        endInstance.reDrawCells();
                        fillInputs();
                    }
                });

                jQuery('.gt-caleran-departure').caleran({
                    startDate: moment(gtArrival),
                    endDate: moment(gtDeparture),
                    minDate: moment(state.openingDate) < moment() ? moment() : moment(state.openingDate),
                    maxDate: moment(state.closingDate),
                    hideOutOfRange: true,
                    enableSwipe: true,
                    startOnMonday: true,
                    enableKeyboard: true,
                    autoCloseOnSelect: true,
                    locale: language,
                    enableMonthSwitcher: true,
                    enableYearSwitcher: true,
                    ranges: generateRanges(gtArrival),
                    format: language === "en" ? "DD/MM/YYYY" : "DD/MM/YYYY",
                    oninit: function (instance) {
                        endInstance = instance;
                        if (!instance.config.startEmpty && instance.config.endDate) {
                            instance.$elem.val(instance.config.endDate.locale(instance.config.format).format(instance.config.format));
                            endDate = instance.config.endDate.clone();
                        }
                    },
                    onbeforeshow: function (instance) {
                        if (startDate) {
                            startInstance.config.startDate = startDate;
                            endInstance.config.startDate = startDate;
                        }
                        if (endDate) {
                            startInstance.config.endDate = endDate.clone();
                            endInstance.config.endDate = endDate.clone();
                        }
                        fillInputs();
                        instance.updateHeader();
                        instance.reDrawCells();
                    },
                    onafterselect: function (instance, start, end) {
                        startDate = start.clone();
                        endDate = end.clone();
                        endInstance.hideDropdown();
                        startInstance.config.endDate = endDate.clone();
                        startInstance.globals.firstValueSelected = true;
                        fillInputs();
                        endInstance.globals.startSelected = true;
                        endInstance.globals.endSelected = false;
                        
                        state.gtArrival = start.format('DD/MM/YYYY');
                        state.gtDeparture = end.format('DD/MM/YYYY');

                        instance.config.ranges = generateRanges(state.gtArrival);
                        instance.reDrawCalendars();


                        jQuery(".gt-caleran-merged, .gt-caleran-arrival, .gt-arrival-departure").each(function(){
                            const caleranInstance = jQuery(this).data("caleran");
                            caleranInstance.config.startDate = startDate;
                            caleranInstance.config.endDate = endDate;
                            caleranInstance.reDrawCalendars();
                        });

                    }
                });
            }

            bindMobileCaleranTapGuard();

        },
        toggleStickyForm: (e) => {
            const element = getElement();
            element.ref.closest('.wp-block-gt-gt-ws-ctv-form-resa').classList.toggle('toggled');
        },
        stickyForm: (e) => {
            e.preventDefault();
            const element = getElement();
            const context = getContext();

            const elementBottom = element.ref.getBoundingClientRect().bottom + window.scrollY;
            const trigger = context.isStickyAfterScroll ? context.isStickyAfterScroll : elementBottom
            

            const scrollTop = window.scrollY;

            if (scrollTop > 1000) {
                element.ref.classList.add('sticked');
            } else {
                element.ref.classList.remove('sticked');
            }

            element.ref.classList.remove('toggled');


        },
        submitForm: (e) => {
            
            if (e && e.__gtHandledSubmit) return;
            if (e) {
                e.__gtHandledSubmit = true;
                e.preventDefault();
                e.stopPropagation();
            }

            console.log('🔍 submitForm appelé', { 
                e, 
                loaded: state.loaded, 
                gtArrival: state.gtArrival, 
                gtDeparture: state.gtDeparture, 
                gtNbPers: state.gtNbPers,
                isCampingPage: state.isCampingPage,
                idSite: state.idSite,
                postType: typeof state.isCampingPage !== 'undefined' ? 'camping' : 'other'
            });

            if(state.loaded == true && e == undefined) {
                console.log('⚠️ Retour car loaded=true et e=undefined');
                return;
            }

            state.isLoading = true;
            state.loaded = false;

            if(state.gtArrival == "null" || state.gtDeparture == "null" || state.gtNbPers == "null"){
                console.log('⚠️ Retour car dates ou nbPers sont null');
                state.isLoading = false;
                return;
            }

            // Sauvegarder dans les cookies
            Cookies.set('gtArrival', state.gtArrival);
            Cookies.set('gtDeparture', state.gtDeparture);
            Cookies.set('gtNbPers', state.gtNbPers);
            Cookies.set('gtType', state.gtType);
            Cookies.set('gtCamping', state.gtCamping);
            Cookies.set('gtRegion', state.gtRegion);
            Cookies.set('gtDepartment', state.gtDepartment);

            // Construire l'URL de redirection vers secureholiday.net
            // Si on est sur une page camping, rediriger vers estab-view avec l'ID du camping
            console.log('🔍 État du state pour redirection:', {
                isCampingPage: state.isCampingPage,
                idSite: state.idSite,
                typeIsCampingPage: typeof state.isCampingPage,
                typeIdSite: typeof state.idSite
            });
            
            let baseUrl;
            let isCampingView = false;
            const secureholidayLanguage = getSecureholidayLanguage(state.language);
            if (state.isCampingPage === true && state.idSite) {
                baseUrl = `https://reservation.secureholiday.net/group/${secureholidayLanguage}/297/search/estab-view/${state.idSite}/products`;
                isCampingView = true;
                console.log('✅ Redirection vers estab-view pour camping:', state.idSite, 'URL:', baseUrl);
            } else {
                baseUrl = `https://reservation.secureholiday.net/group/${secureholidayLanguage}/297/search/estab-list`;
                console.log('ℹ️ Redirection vers estab-list (page normale) - isCampingPage:', state.isCampingPage, 'idSite:', state.idSite);
            }
            const url = new URL(baseUrl);
            
            // Dates : format DD/MM/YYYY
            // Récupérer depuis le formulaire exactement comme dans le plugin (ligne 273-287)
            const form = e?.target?.closest('form') || document.querySelector('.gt-ws-ctv-form-resa');
            let dateStart, dateEnd;
            
            console.log('🔍 Recherche du formulaire:', form);
            
            if (form) {
                // Vérifier si c'est un input merged (plage de dates) ou deux inputs séparés
                const mergedInput = form.querySelector('.gt-caleran-merged');
                const arrivalInput = form.querySelector('.gt-caleran-arrival');
                const departureInput = form.querySelector('.gt-caleran-departure');
                
                console.log('🔍 Inputs trouvés:', {
                    merged: mergedInput ? { exists: true, value: mergedInput.value } : { exists: false },
                    arrival: arrivalInput ? { exists: true, value: arrivalInput.value } : { exists: false },
                    departure: departureInput ? { exists: true, value: departureInput.value } : { exists: false }
                });
                
                if (mergedInput && mergedInput.value) {
                    // Si c'est un seul input pour la plage, récupérer la valeur et la scinder (comme ligne 281-286 du plugin)
                    let rangeVal = mergedInput.value;
                    console.log('📅 Valeur merged trouvée:', rangeVal);
                    if (rangeVal) {
                        let ranges = rangeVal.split(' - ');
                        console.log('📅 Ranges après split:', ranges);
                        dateStart = ranges[0] ? ranges[0].trim() : '';
                        dateEnd = ranges[1] ? ranges[1].trim() : '';
                        console.log('📅 Dates extraites:', { dateStart, dateEnd });
                    }
                } else if (arrivalInput || departureInput) {
                    // Si c'est deux inputs séparés (comme ligne 277-278 du plugin)
                    dateStart = arrivalInput && arrivalInput.value ? arrivalInput.value.trim() : '';
                    dateEnd = departureInput && departureInput.value ? departureInput.value.trim() : '';
                    console.log('📅 Dates depuis inputs séparés:', { dateStart, dateEnd });
                }
            }
            
            // Si toujours pas de dates, essayer depuis le state
            if (!dateStart || !dateEnd) {
                console.log('⚠️ Dates non trouvées dans le formulaire, utilisation du state');
                dateStart = state.gtArrival || '';
                dateEnd = state.gtDeparture || '';
                console.log('📅 Dates depuis state:', { dateStart, dateEnd });
            }
            
            console.log('📅 Dates récupérées:', {
                fromState: { dateStart: state.gtArrival, dateEnd: state.gtDeparture },
                final: { dateStart, dateEnd },
                dateStartType: typeof dateStart,
                dateEndType: typeof dateEnd,
                dateStartLength: dateStart?.length,
                dateEndLength: dateEnd?.length
            });
            
            // Ajouter les dates si elles existent (pour estab-view ET estab-list)
            if (dateStart && dateStart !== 'null' && dateStart !== '') {
                url.searchParams.set('dateStart', dateStart);
                console.log('✅ dateStart ajouté à l\'URL:', dateStart, 'URL après:', url.toString());
            } else {
                console.log('⚠️ dateStart non ajouté - valeur:', dateStart, 'type:', typeof dateStart, 'est null?', dateStart === 'null', 'est vide?', dateStart === '');
            }
            if (dateEnd && dateEnd !== 'null' && dateEnd !== '') {
                url.searchParams.set('dateEnd', dateEnd);
                console.log('✅ dateEnd ajouté à l\'URL:', dateEnd, 'URL après:', url.toString());
            } else {
                console.log('⚠️ dateEnd non ajouté - valeur:', dateEnd, 'type:', typeof dateEnd, 'est null?', dateEnd === 'null', 'est vide?', dateEnd === '');
            }
            
            // Vérification immédiate après ajout
            console.log('🔍 Vérification immédiate des paramètres dans l\'URL:', {
                dateStart: url.searchParams.get('dateStart'),
                dateEnd: url.searchParams.get('dateEnd'),
                urlString: url.toString()
            });
            
            // Nombre de personnes : format "nombre@"
            const travelers = state.gtNbPers ? state.gtNbPers + '@' : '';
            if (travelers) {
                url.searchParams.set('travelers', travelers);
            }
            
            // Si on redirige vers estab-view, ne pas ajouter les autres paramètres (showMap, productType, to)
            // Juste les dates et le nombre de personnes
            if (isCampingView) {
                console.log('🔗 Redirection vers estab-view avec dates et nombre de personnes:', url.toString());
                window.open(url.toString(), '_blank');
                state.isLoading = false;
                return;
            }
            
            // Paramètres supplémentaires pour estab-list uniquement
            url.searchParams.set('showMap', 'true');
            
            // Type de produit : all, accommodation, pitch, etc.
            let productType = 'false';
            // state.gtType peut être un tableau ou une chaîne
            let gtTypeValue = Array.isArray(state.gtType) ? (state.gtType[0] || '') : (state.gtType || '');
            if (gtTypeValue && gtTypeValue !== 'null' && gtTypeValue !== '') {
                // Convertir le type si nécessaire
                if (gtTypeValue === 'accommodation' || gtTypeValue === 'location' || gtTypeValue === 'Location') {
                    productType = 'accommodation';
                } else if (gtTypeValue === 'pitch' || gtTypeValue === 'emplacement' || gtTypeValue === 'Emplacement') {
                    productType = 'pitch';
                } else {
                    productType = gtTypeValue;
                }
            }
            url.searchParams.set('productType', productType);
            
            // Mapping des départements avec leurs IDs OSM
            const departmentOsmIds = {
                'ardennes': { label: 'Ardennes', id: 7395 },
                'aube': { label: 'Aube', id: 7441 },
                'marne': { label: 'Marne', id: 7379 },
                'haute-marne': { label: 'Haute-Marne', id: 7396 },
                'meurthe-et-moselle': { label: 'Meurthe-et-Moselle', id: 51856 },
                'meuse': { label: 'Meuse', id: 7382 },
                'moselle': { label: 'Moselle', id: 51854 },
                'bas-rhin': { label: 'Bas-Rhin', id: 7384 },
                'haut-rhin': { label: 'Haut-Rhin', id: 7403 },
                'vosges': { label: 'Vosges', id: 7384 }
            };
            const normalizeDepartmentKey = (value) => (value || '')
                .toString()
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(/\p{Diacritic}/gu, '')
                .replace(/^l['’]\s*/i, '')
                .replace(/^la\s+/i, '')
                .replace(/^le\s+/i, '');
            const departmentFromState = Array.isArray(state.gtDepartment) ? state.gtDepartment[0] : state.gtDepartment;
            const departmentFromForm = form?.querySelector('.gt-select-department')?.value;
            const departmentFromSelect = document.querySelector('.gt-select-department')?.value;
            const departmentFromUrl = new URLSearchParams(window.location.search).get('department');
            const pickDepartmentValue = (...values) => {
                for (const val of values) {
                    const str = (val ?? '').toString().trim();
                    if (str && str !== 'null' && str !== 'undefined') {
                        return str;
                    }
                }
                return '';
            };
            const departmentValue = pickDepartmentValue(departmentFromForm, departmentFromSelect, departmentFromState, departmentFromUrl);
            const campingId = Array.isArray(state.gtCamping) ? state.gtCamping[0] : state.gtCamping;
            
            console.log('🏕️ Debug département et camping:', {
                gtDepartment: state.gtDepartment,
                departmentValue: departmentValue,
                gtCamping: state.gtCamping,
                campingId: campingId,
                campings: state.campings,
                campingsLength: state.campings?.length
            });
            
            let selectedDepartmentMeta = null;
            // Si un département est sélectionné, utiliser le paramètre "to" pour le département
            if (departmentValue && departmentValue !== 'null' && departmentValue !== '') {
                const departmentName = departmentValue.toString().trim();
                const departmentMeta = departmentOsmIds[normalizeDepartmentKey(departmentName)];
                
                if (departmentMeta?.id) {
                    selectedDepartmentMeta = departmentMeta;
                    // Format: to=~(n~'NomDépartement~osm~(~ID_OSM))
                    const toParam = `~(n~'${departmentMeta.label}~osm~(~${departmentMeta.id}))`;
                    url.searchParams.set('to', toParam);
                    url.searchParams.set('department', departmentMeta.label);
                    console.log('🏛️ Paramètre "to" ajouté pour le département:', toParam, 'Département:', departmentMeta.label, 'OSM ID:', departmentMeta.id);
                } else {
                    console.log('⚠️ Département sélectionné mais ID OSM non trouvé:', departmentName);
                }
            } 
            // Si "Tous les départements" est sélectionné, utiliser "Grand Est"
            else {
                // Format exact fourni: ~%28n~%27Grand%2a20Est~osm~%28~3792876%29%29
                // Décodé: ~(n~'Grand Est~osm~(~3792876))
                const grandEstParam = `~(n~'Grand Est~osm~(~3792876))`;
                url.searchParams.set('to', grandEstParam);
                console.log('🏛️ Paramètre "to" ajouté pour Grand Est (tous les départements):', grandEstParam);
            }
            
            // Si un camping est sélectionné ET aucun département n'est sélectionné, utiliser le paramètre "to" pour le camping
            if (campingId && campingId !== 'null' && campingId !== '' && (!departmentValue || departmentValue === '' || departmentValue === 'null')) {
                let campingName = '';
                let campingSiteId = campingId.toString();
                
                // Méthode 1: Chercher dans state.campings
                if (state.campings && Array.isArray(state.campings) && state.campings.length > 0) {
                    const selectedCamping = state.campings.find(c => {
                        const cId = c.id?.toString() || c.idSite?.toString() || c.campingKey?.toString();
                        return cId === campingId.toString();
                    });
                    
                    if (selectedCamping) {
                        campingName = selectedCamping.name || '';
                        campingSiteId = selectedCamping.idSite?.toString() || selectedCamping.campingKey?.toString() || campingId.toString();
                        console.log('✅ Camping trouvé dans state.campings:', selectedCamping);
                    }
                }
                
                // Méthode 2: Si pas trouvé, récupérer depuis le select du formulaire
                if (!campingName) {
                    const campingSelect = document.querySelector('.gt-select-camping');
                    if (campingSelect && campingSelect.value === campingId.toString()) {
                        const selectedOption = campingSelect.options[campingSelect.selectedIndex];
                        if (selectedOption && selectedOption.text) {
                            campingName = selectedOption.text.trim();
                            campingSiteId = campingId.toString();
                            console.log('✅ Camping trouvé dans le select:', { name: campingName, id: campingSiteId });
                        }
                    }
                }
                
                // Si on a un nom de camping, construire le paramètre "to"
                if (campingName) {
                    // Remplacer les espaces par *20 dans le nom
                    const campingNameEncoded = campingName.replace(/\s/g, '*20');
                    // Construire le paramètre: ~(n~'Nom*20~e~ID)
                    const toParam = `~(n~'${campingNameEncoded}~e~${campingSiteId})`;
                    url.searchParams.set('to', toParam);
                    console.log('🏕️ Paramètre "to" ajouté:', toParam, 'pour le camping:', campingName, 'ID:', campingSiteId);
                } else {
                    console.log('⚠️ Camping sélectionné mais nom non trouvé, ID:', campingId);
                    console.log('⚠️ État complet:', {
                        gtCamping: state.gtCamping,
                        campings: state.campings,
                        select: document.querySelector('.gt-select-camping')?.value
                    });
                }
            } else {
                console.log('ℹ️ Aucun département ni camping sélectionné');
            }

            // Close menu
            if(store('gt-menu-burger').actions.length > 0){
                store('gt-menu-burger').actions.closeMenu();
            }

            // Priorité stricte au département: empêcher tout fallback "Zone sur la carte".
            if (selectedDepartmentMeta?.id) {
                const enforcedToParam = `~(n~'${selectedDepartmentMeta.label}~osm~(~${selectedDepartmentMeta.id}))`;
                url.searchParams.set('to', enforcedToParam);
                url.searchParams.set('department', selectedDepartmentMeta.label);
                url.searchParams.delete('radius');
                url.searchParams.delete('lat');
                url.searchParams.delete('lng');
            }

            // Log pour debug - Vérifier l'URL finale
            const finalUrl = url.toString();
            console.log('🔗 URL finale complète:', finalUrl);
            console.log('📋 Paramètres dans l\'URL:', {
                dateStart: url.searchParams.get('dateStart'),
                dateEnd: url.searchParams.get('dateEnd'),
                travelers: url.searchParams.get('travelers'),
                productType: url.searchParams.get('productType'),
                to: url.searchParams.get('to'),
                showMap: url.searchParams.get('showMap')
            });
            console.log('📋 Paramètres bruts:', {
                dateStart: dateStart,
                dateEnd: dateEnd,
                travelers: travelers,
                productType: productType
            });

            // Ouvrir dans un nouvel onglet
            window.open(url.toString(), '_blank');

        },
        callbacks:{
          
        }
    }
});

// Filtrer les campings au chargement de la page si un paramètre region est présent dans l'URL
document.addEventListener('DOMContentLoaded', function() {
    const urlParams = new URLSearchParams(window.location.search);
    const regionParam = urlParams.get('region');
    
    if (regionParam) {
        // Attendre que les campings soient chargés
        setTimeout(() => {
            const normalize = (str) => (str || '')
                .toString()
                .trim()
                .toLowerCase()
                .normalize('NFD')
                .replace(/\p{Diacritic}/gu, '');
            
            const normalizedSelected = normalize(regionParam);
            
            // Trouver tous les éléments de camping
            const campingElements = document.querySelectorAll('.wp-block-query[data-namespace="gt-ws-ctv-campings"] li, .gt-ws-ctv-campings-block li, [data-region]');
            
            campingElements.forEach(campingElement => {
                const campingRegion = campingElement.getAttribute('data-region');
                
                if (campingRegion) {
                    const normalizedCampingRegion = normalize(campingRegion);
                    const matches = normalizedCampingRegion === normalizedSelected || campingRegion === regionParam;
                    campingElement.style.display = matches ? '' : 'none';
                } else {
                    // Si le camping n'a pas d'attribut data-region, le masquer par défaut
                    campingElement.style.display = 'none';
                }
            });
        }, 100);
    }
});

const updateURL = async (url) => {
    const router = await import('@wordpress/interactivity-router');
    
    // await router.actions.prefetch(url.toString(),{
    //     // force:false
    // });

    // Navigate to the updated URL
    // Utiliser force: true pour forcer le rechargement des blocs Query Loop
    // surtout quand le paramètre region change
    await router.actions.navigate(url.toString(), {
        force: true, // Forcer le rechargement pour que les blocs Query Loop se mettent à jour
        replace: true,
        // timeout:20000
    });

    fetch(`${state.baseUrl}disponibilites/?arrival=${state.gtArrival}&departure=${state.gtDeparture}&nbPers=${state.gtNbPers}&lang=${state.language}&site_id=${state.siteId}`)
        .then(response => response.json())
        .then(disponibilitesData => {
            let stays = {};
            state.allProductIds.forEach(productId => {
                stays[productId] = disponibilitesData[productId] || [];
            });
            state.stays = stays;


            // If all empty arrays - seulement pour les disponibilités, pas pour les campings
            if (Object.values(stays).every(arr => arr.length === 0)) {
                // Vérifier si on est sur une page avec des disponibilités
                const hasDisponibilitesBlocks = document.querySelector('.wp-block-gt-gt-ws-ctv-disponibilites') || 
                                               document.querySelector('.gt-ws-ctv-disponibilites-query') ||
                                               document.querySelector('.gt-ws-ctv-contrepropositions-query');
                
                // Ajouter gtNoResults seulement si on a des blocs de disponibilités
                if (hasDisponibilitesBlocks && !url.searchParams.has('gtNoResults')) {
                    url.searchParams.set('gtNoResults', 'true');
                    updateURL(url);
                    return;
                }
            }


        })
        .catch(error => console.error("Erreur lors de la récupération des disponibilités:", error))
        .finally(() => {

            
            store('gt/ctv').actions.sortHebergements();

            const event = new CustomEvent('gt_ws_ctv_updated');
            window.dispatchEvent(event);

            state.isLoading = false;
            state.loaded = true;

        });

};

document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('.gt-ws-ctv-form-resa')) return;
    if (event.__gtHandledSubmit) return;

    event.__gtHandledSubmit = true;
    event.preventDefault();
    event.stopPropagation();

    try {
        store('gt/ctv').actions.submitForm(event);
    } catch (err) {
        console.error('Erreur interception submit form-resa:', err);
    }
}, true);

